import Param from '../../param';
import effectManager from '../effect';
import Util from '../../util';


const param = new Param();
const effect = new effectManager();
const util = new Util();

export default class Panel{
    constructor(w,h,pixelRato){


        this.w = w;
        this.h = h;


        this.scene;
        this.camera;
        this.renderer;
        this.controls;

        this.loaded = false;
        this.geo = "";
        this.mat = "";
        this.mesh= "";
        this.uniforms="";

        this.cover = {
        }; /* メインビジュアルのテクスチャ */
        this.pixelRato = pixelRato;

        this.renderMode = "normal"; /* low || normal FPSが低下していたら切り替え */

        this.time = 0;
    }
    init(scene,camera,renderer){


        let _this = this;

        this.scene = scene;
        this.camera = camera;
        this.renderer = renderer;

        // _this.bg.geo = new THREE.PlaneBufferGeometry(2,1.125);
        _this.geo = new THREE.PlaneBufferGeometry(14/140*0.2,1.0*0.2);

        _this.uniforms = {
            time:{type:"f",value:1.0},
            // resolution:{type:"v2",value:new THREE.Vector2()},
            point:{type:"v2",value:new THREE.Vector2()},
        }


        this.uniforms.point.value.x = 1.0;
        this.uniforms.point.value.y = 1.0;

        _this.mat = new THREE.ShaderMaterial({
            uniforms: _this.uniforms,
            vertexShader: param.webgl.panel.shader.vert,
            fragmentShader: param.webgl.panel.shader.frag,
            // transparent   :true,
        });

        _this.mesh = new THREE.Mesh( _this.geo, _this.mat );

        _this.mesh.position.z = 0;

        _this.scene.add( _this.mesh );



        // _this.bg.tex = new THREE.TextureLoader().load(param.webgl.mainvisual.img[0],function () {
        //     // _this.bg.tex.minFilter = THREE.LinearFilter;
        //     createBg.init(_this.bg.geo,_this.bg.tex,_this.scene);
        //
        //
        //
        //     _this.resize();
        //
        //     // _this.datGUI();
        //
        // });



    }

    render(mouse,renderMode) {

        this.time +=0.01;

        // createBg.render();
        // this.uniforms.time += 0.001;
        // this.mat.uniforms.time.value += 0.01;
        // this.mat.uniforms.point.value.x = (Math.sin(this.time) + 1.0) * 0.8;
        // this.mat.uniforms.point.value.y = (Math.cos(this.time) + 1.0) * 0.8;

    }
    resize(w,h){
        this.w = w;
        this.h = h;

        // this.mat.uniforms.resolution.value.x = this.w;
        // this.mat.uniforms.resolution.value.y = this.h;

    }


}